import React from 'react';
import { ReactComponent as Icon } from '../../../assets/icon-log-out.svg';
import createSvgIcon from '../../../shared/utils/create-svg-icon';

export const LogOutIcon = createSvgIcon(<Icon />, 'LogOutIcon');
